import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Replace, Clear } from '../../stores/sellers/actions';
import useSearchParameters from './useSearchParameters';
import useUser from "../user/useUser";

// Service
import SellerService from '../../services/sellerService';

const useSellers = () => {
    const { business } = useUser();
    const { sellers } = useSelector(state => state.sellers_data);
    const { textField, pageSize, pageNumber, replacePageNumber, replacePageSize, setTextField } = useSearchParameters();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        return () => dispatch(Clear())
    }, [dispatch])

    useEffect(() => {
        const FindSellers = () => {
            setLoading(true);
            SellerService
                .Search(pageSize, pageNumber, textField, business.id) 
                .then(res => dispatch(Replace(res.values, res.totalResults, res.totalPage)))
                .finally(() => setLoading(false));
        }

        if(business?.id)
            FindSellers();
    }, [dispatch, pageSize, pageNumber, textField, business?.id])

    return {
        pageNumber,
        pageSize,
        sellers,
        loading,
        textField,
        replacePageSize,
        replacePageNumber,
        setTextField,
    }
}

export default useSellers;